export const titleAreaStyleProps = {
    backgroundColor: 'background.gray',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingX: '24px',
    paddingY: {base: '24px', mobileXL: '32px'},
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'accent',
};

export const titleStyleProps = {
    color: 'text.primary.light',
    fontSize: '24px',
    fontWeight: 'semibold',
    lineHeight: 1.5,
    textAlign: 'center',
};
